function firstText(...values) {
  for (const value of values) {
    if (value === null || value === undefined) continue;
    const text = String(value).trim();
    if (text) return text;
  }
  return '';
}

function getScopeSource(source = {}) {
  const nestedScope = source?.scope && typeof source.scope === 'object' ? source.scope : {};

  return {
    level: firstText(
      nestedScope.level,
      nestedScope.scopeLevel,
      nestedScope.scope_level,
      source.level,
      source.scopeLevel,
      source.scope_level
    ),
    state: firstText(
      nestedScope.state,
      nestedScope.state_name,
      nestedScope.stateName,
      source.state,
      source.state_name,
      source.stateName,
      source.assignedState,
      source.assigned_state
    ),
    lga: firstText(
      nestedScope.lga,
      nestedScope.lga_name,
      nestedScope.lgaName,
      source.lga,
      source.lga_name,
      source.lgaName,
      source.assignedLga,
      source.assigned_lga
    ),
    ward: firstText(
      nestedScope.ward,
      nestedScope.ward_name,
      nestedScope.wardName,
      source.ward,
      source.ward_name,
      source.wardName,
      source.assignedWard,
      source.assigned_ward
    ),
  };
}

export function extractScopeSeed(source = {}) {
  const scope = getScopeSource(source);
  return {
    level: scope.level || (scope.lga ? 'lga' : scope.state ? 'state' : 'national'),
    state: scope.state || null,
    lga: scope.lga || null,
    ward: scope.ward || null,
  };
}

export function extractLocationFields(source = {}) {
  const scope = getScopeSource(source);
  return {
    state: scope.state || null,
    lga: scope.lga || null,
    ward: scope.ward || null,
  };
}
